/**
 * Formatter: Transform lens insight data → chat prompt
 */

import INSIGHT_TO_CHAT_PROMPT_GUIDED from '../templates/insight-to-chat-prompt-guided'

export interface InsightData {
  conceptName?: string
  codeElement: string
  sourceLanguage: string
  targetLanguage: string
  source: string
  target: string
  concept?: string
  paradigm?: string
}

/**
 * Transform insight data into chat-ready prompt
 *
 * @param data - Lens insight data
 * @param template - Template to use (defaults to guided approach)
 * @returns Formatted chat prompt text
 */
export const formatInsightToChatPrompt = (
  data: InsightData,
  template = INSIGHT_TO_CHAT_PROMPT_GUIDED
): string => {
  // Build intro with context
  let content = template.buildIntro(
    data.sourceLanguage,
    data.targetLanguage,
    data.codeElement
  )

  // Add syntax transformation
  content += `**Syntax Transformation:**\n`
  content += `- ${data.sourceLanguage}: \`${data.source || '(similar)'}\`\n`
  content += `- ${data.targetLanguage}: \`${data.target}\`\n\n`

  // Add semantic meaning if available
  if (data.concept) {
    const clean = data.concept.replace(/<[^>]*>/g, '').replace(/`/g, '')
    content += `**Semantic Meaning:** ${clean}\n\n`
  }

  // Add paradigm shift if available
  if (data.paradigm) {
    const clean = data.paradigm.replace(/<[^>]*>/g, '').replace(/`/g, '')
    content += `**Paradigm Shift:** ${clean}\n`
  }

  // Add follow-up questions
  content += template.buildQuestions(data.targetLanguage)

  return content
}
